import React from 'react'
import { ArrowUpIcon, ArrowDownIcon } from './Icons'
import { formatCompactNumber } from '../../../utils'
import DataTypeSelect from './components/DataTypeSelect'

const OverviewSection = ({
  safeTotalPopulation,
  safeGrowthRate,
  singlePolygonData,
  polygonData,
  rightSidebarStore
}) => {
  const isNegativeGrowth = safeGrowthRate != null && parseFloat(safeGrowthRate) < 0
  const ArrowIcon = isNegativeGrowth ? ArrowDownIcon : ArrowUpIcon

  return (
    <div className='people-data-sidebar__section'>
      <div className='people-data-sidebar__section-header'>
        <h3 className='people-data-sidebar__section-title'>Overview</h3>
        <div className='people-data-sidebar__dropdown'>
          <DataTypeSelect />
        </div>
      </div>
      <div className='people-data-sidebar__overview-grid'>
        <div className='people-data-sidebar__overview-item'>
          <div className='people-data-sidebar__overview-value'>
            {safeTotalPopulation ? formatCompactNumber(safeTotalPopulation) : 0}
            {/* <span className="people-data-sidebar__overview-arrow">
              <ArrowUpIcon />
            </span> */}
          </div>
          <div className='people-data-sidebar__overview-label'>Population</div>
        </div>
        <div className='people-data-sidebar__overview-item'>
          <div className='people-data-sidebar__overview-value'>
            {(() => {
              const rate = parseFloat(safeGrowthRate)
              if (isNaN(rate)) return '0%'
              return `${safeGrowthRate}%`
            })()}
            <span className='people-data-sidebar__overview-arrow'>
              <ArrowIcon />
            </span>
          </div>
          <div className='people-data-sidebar__overview-label'>Growth Rate</div>
        </div>
      </div>
    </div>
  )
}

export default OverviewSection
